import React, { FC } from 'react';

import { useReactionMenu } from '../helpers/hooks';
import ReactionMenu from '../ReactionMenu';
import ReactionsModal from '../ReactionsModal';
import { StyledInteractiveListReactionMenuWrap } from './styled';

const InteractiveReactionMenu: FC<{
  entityId: string;
  children: JSX.Element;
  isReactionDisabled?: boolean;
  isCursorGrab?: boolean;
}> = ({ entityId, children, isReactionDisabled, isCursorGrab }) => {
  const {
    isReactionsModalOpen,
    reactionCoordinates,
    isQuickReactionOpen,
    setIsQuickReactionOpen,
    setIsReactionsModalOpen,
    infoRef,
  } = useReactionMenu();

  return (
    <StyledInteractiveListReactionMenuWrap ref={infoRef} isPointer={!isReactionDisabled} isCursorGrab={!!isCursorGrab}>
      {children}
      {reactionCoordinates && reactionCoordinates.x && reactionCoordinates.y && (
        <ReactionMenu
          isOpen={isQuickReactionOpen}
          anchorPoint={reactionCoordinates}
          onClose={() => setIsQuickReactionOpen(false)}
          onSend={() => {}}
          onEmoji={() => {}}
          onOpenReactionsModal={() => setIsReactionsModalOpen(true)}
        />
      )}
      {isReactionsModalOpen && <ReactionsModal id={entityId} handleClose={() => setIsReactionsModalOpen(false)} />}
    </StyledInteractiveListReactionMenuWrap>
  );
};

export default InteractiveReactionMenu;
